import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import ConfigStore from 'stores/config/ConfigStore'

import TabBar from 'components/tabBar/TabBar'
import SettingsDropdown from 'components/settingsDropdown/settingsDropdown'

import styles from './header.scss'

interface IProps {
  className?: string
}

const Header = ({ className }: IProps) => {
  return (
    <div
      data-cy="header"
      className={cn(styles.container, className)}
      style={{ paddingLeft: ConfigStore.headerLeftOffset }}
    >
      <TabBar />
      <SettingsDropdown />
    </div>
  )
}

export default observer(Header)
